import React from "react";
import * as Styles from "../checkbox-group.styles";
import { Checkbox } from "../../checkbox";

export const CheckboxWithNestedCheckboxes = ({
  name,
  value,
  label,
  selectedValue,
  nestedInputValue,
  onNestedInputChange,
  onToggleOn,
  onToggleOff,
  nestedOptions,
}) => {
  const onToggle = () => {
    if (selectedValue) {
      onToggleOff();
    } else {
      onToggleOn(value);
    }
  };

  const isNestedCheckboxChecked = (checkboxValue) => {
    if (!nestedInputValue) return false;
    const selectedItems = nestedInputValue.split(",");
    return selectedItems.some((item) => item === checkboxValue);
  };

  return (
    <>
      <Checkbox
        label={label}
        name={name}
        value={value}
        checked={selectedValue}
        onChange={onToggle}
      />
      {nestedOptions.map((nestedOption) => (
        <Styles.NestedOptionWrapper
          key={`${name}-${value}-${nestedOption.value}`}
        >
          <Checkbox
            label={nestedOption.label}
            name={name}
            value={nestedOption.value}
            checked={isNestedCheckboxChecked(nestedOption.value)}
            onChange={() => onNestedInputChange(nestedOption.value)}
          />
        </Styles.NestedOptionWrapper>
      ))}
    </>
  );
};
